import { useRef, useEffect, useState, useLayoutEffect } from "react";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

import aflorPreview from "./../../Assets/Portfolio/Thumbnails/aflor_preview.webp";
import csswekitPreview from "./../../Assets/Portfolio/Thumbnails/csswebkit_preview.webp";
import elisePreview from "./../../Assets/Portfolio/Thumbnails/elise_preview.webp";
import quasarsPreview from "./../../Assets/Portfolio/Thumbnails/quasars_preview.webp";
import awtPreview from "./../../Assets/Portfolio/Thumbnails/awt_preview.webp";
import djPreview from "./../../Assets/Portfolio/Thumbnails/dj_preview.webp";
import sunPreview from "./../../Assets/Portfolio/Thumbnails/sunagency_preview.webp";

// SubComponents
import CircleSVGAnimated from "./CircleSVGAnimated";

import "./HorizontalScroll.scss";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

const HorizontalScroll = () => {
  let stickyTitle = useRef(null);
  let stickyPercentage = useRef(null);

  const [isClicked, setIsClicked] = useState(null);
  const size = useWindowSize();

  const [horizontalProgressBar, setHorozontalProgressBar] = useState("");
  const [, setBackgroundColor] = useState("white");

  const [portfolioList] = useState([
    { image: aflorPreview, description: "" },
    { image: csswekitPreview, description: "" },
    { image: elisePreview, description: "" },

    { image: sunPreview, description: "" },
    { image: awtPreview, description: "" },
    { image: djPreview, description: "" },
    { image: quasarsPreview, description: "" },
  ]);

  const panels = useRef([]);
  const panelsContainer = useRef();

  const createPanelsRefs = (panel, index) => {
    panels.current[index] = panel;
  };

  useLayoutEffect(() => {
    let title = stickyTitle.current;
    let percentage = stickyPercentage.current;
    const totalPanels = panels.current.length;
    if (size.width >= 1200) {
      gsap.to(panels.current, {
        xPercent: -100 * (totalPanels - 1),
        // x: () =>
        //   -(
        //     container.scrollWidth -
        //     document.documentElement.clientWidth -
        //     slide.clientWidth -
        //     300
        //   ) + "px",
        yoyoEase: true,
        // ease: "none",
        scrollTrigger: {
          trigger: panelsContainer.current,
          pin: true,
          scrub: 1,
          snap: 1 / (totalPanels - 1),
          // base vertical scrolling on how wide the container is so it feels more natural.
          end: () => "+=" + panelsContainer.current.offsetWidth,
          onUpdate: (self) =>
            setHorozontalProgressBar(Math.round(self.progress * 100)),
        },
      });

      gsap.fromTo(
        title,
        {
          opacity: 0,
        },
        {
          scrollTrigger: {
            trigger: title,
            start: "center 30px",
            pin: true,
            pinSpacing: "100px",
            // markers: true,
            scrub: 1,
            snap: 1 / (totalPanels - 1),
            end: () => "+=" + panelsContainer.current.offsetWidth,
          },
          opacity: 1,

          onComplete: () => {
            gsap.to(title, {
              opacity: 0,
            });
          },
        }
      );
      gsap.fromTo(
        percentage,
        {
          opacity: 0,
        },
        {
          scrollTrigger: {
            trigger: title,
            start: "center 30px",
            pin: true,
            pinSpacing: "0",
            // markers: true,
            scrub: 1,
            snap: 1 / (totalPanels - 1),
            end: () => "+=" + panelsContainer.current.offsetWidth,
          },
          opacity: 1,

          onComplete: () => {
            gsap.to(title, {
              opacity: 0,
            });
          },
        }
      );
    }

    console.log(size.width);
    // eslint-disable-next-line no-sparse-arrays
  }, [size.width]);

  // useLayoutEffect(() => {
  //   let container = slideContainer.current;
  //   let slide = slideSection.current;
  //   let title = stickyTitle.current;

  //   gsap.to(container, {
  //     x: () =>
  //       -(
  //         container.scrollWidth -
  //         document.documentElement.clientWidth -
  //         slide.clientWidth -
  //         300
  //       ) + "px",
  //     // yoyoEase: true,

  //     scrollTrigger: {
  //       trigger: container,
  //       start: "top top",
  //       pin: true,
  //       scrub: 1,
  //       yoyo: true,
  //       snap: 1 / (container.offsetWidth - 1),

  //       anticipatePin: 1, // can help avoid flash

  //       end: () => "+=" + container.offsetWidth,
  //       onUpdate: (self) => setHorozontalProgressBar(self.progress * 100),
  //     },
  //   });

  //   gsap.fromTo(
  //     title,
  //     {
  //       opacity: 0,
  //     },
  //     {
  //       scrollTrigger: {
  //         trigger: title,
  //         start: "center 30px",
  //         pin: true,
  //         pinSpacing: "100px",
  //         // markers: true,
  //         scrub: 1,
  //         snap: 1 / (container.offsetWidth - 1),
  //         // end: () => "+=" + container.offsetWidth,
  //         end: "+=200%",
  //       },
  //       opacity: 1,

  //       onComplete: () => {
  //         gsap.to(title, {
  //           opacity: 0,
  //         });
  //       },
  //     }
  //   );

  //   // eslint-disable-next-line no-sparse-arrays
  // }, [, portfolioList]);

  const showItem = (e, item) => {
    setIsClicked(item);
    console.log("item", item);
  };

  useEffect(() => {
    if (horizontalProgressBar <= 40) {
      setBackgroundColor("#fff");
    }
    if (horizontalProgressBar >= 50) {
      setBackgroundColor("#f7c2a3");
    }

    if (horizontalProgressBar >= 80) {
      setBackgroundColor("#AFFFDE");
    }

    if (horizontalProgressBar >= 90) {
      setBackgroundColor("#AFB9FF");
    }

    if (horizontalProgressBar >= 85) {
      setBackgroundColor("trasparent");
    }
  }, [horizontalProgressBar]);

  return (
    <>
      <div className="horizontal-holder">
        <div className={`lightbox ${isClicked !== "" ? "active" : ""}`}>
          <img src={isClicked} alt="" />
          <span className="close" onClick={() => setIsClicked("")}>
            close
          </span>
        </div>
        <div className="h-scroll-wrapper">
          <div className="top" ref={stickyTitle}>
            <h3>Selected Works </h3>
            {/* <div className="horizontal-progress-full"></div> */}
            <div
              className="horizontal-progress"
              style={{
                width: horizontalProgressBar + "%",
              }}
            ></div>
          </div>

          {/* {horizontalProgressBar <= 99 && (
        <div className="percentage" ref={stickyPercentage}>
          {horizontalProgressBar} %
        </div>
      )} */}

          <div className="horiontal-scroll-container" ref={panelsContainer}>
            <div
              className="slide-section slide-introduction"
              ref={(e) => createPanelsRefs(e, 0)}
            >
              <div className="portfolio-description">
                <CircleSVGAnimated />
                {/* <Introduction /> */}
              </div>
            </div>

            {portfolioList &&
              portfolioList.map((el, index) => (
                <div
                  key={index}
                  className={`slide-section`}
                  ref={(e) => createPanelsRefs(e, index + 1)}
                  onClick={(e) => showItem(e, el.image)}
                >
                  <img src={el.image} alt={el.description} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default HorizontalScroll;
